export const GA = 'G-8CN4YZTYLP';
export const trustedScriptOrigins = [
	location.origin,
	'https://cdn.kernvalley.us',
	'https://unpkg.com',
	'https://www.googletagmanager.com',
	'https://www.google-analytics.com',
];

export const lakeimg = {
	pathname: '/lakecam',
	src: 'https://www.tazdij.com/static/ftp/paradisecove/ftp/cameraview.jpg',
	height: 352,
	width: 640,
	alt: 'Lake Cam',
	id: 'lake-cam-img',
	loading: 'eager',
	crossOrgin: 'anonymous',
	referrerPolicy: 'no-referrer',
	timeout: 15,
	parentSelector: 'section.center',
	queryParam: 'ts',
};
